
import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Auth } from './services/auth'; // Assuming you have an AuthService
import { Observable } from 'rxjs'

//import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})

export class AuthGuard  implements CanActivate {

  constructor(private authService: Auth, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (this.authService.isLoggedIn()) {
      return true; // Allow access
    } else {
      // Redirect to login page if not authenticated
      return this.router.createUrlTree(['/login']); 
    }

  
  }
}
